import { iDontKnowAnswer } from '@/components/decision-tree/hooks';
import { FollowUpType } from '@/components/decision-tree/types';
import IconCatch from '@/components/icons/icon-catch/icon-catch';
import useIsMobile from '@/hooks/use-is-mobile';
import { Box, Divider, Flex, Text, UnorderedList } from '@cmpsr/components';
import { FC, useEffect } from 'react';
import { ResultProps } from './types';

export const Result: FC<ResultProps> = ({ data, saveAnswer, result }) => {
  const { label } = data;
  const isMobile = useIsMobile() ?? true;

  useEffect(() => saveAnswer(iDontKnowAnswer), []);

  return (
    <Box textAlign="center">
      {!result?.length ? (
        <ResultOk label={label} isMobile={isMobile} />
      ) : (
        <ResultFollowUp label={label} results={result} isMobile={isMobile} />
      )}
    </Box>
  );
};

type ResultOkProps = { label: string; isMobile: boolean };

const ResultOk = ({ label, isMobile }: ResultOkProps) => (
  <>
    <IconCatch icon={'congrats-04'} size={isMobile ? 'xl' : 'xxl'} mb="spacer-6" mx="auto" bgColor="none" />
    <Text variant="text-header-XL">
      Congrats! You completed your{' '}
      <Text as="span" textStyle="text-header-xl-v">
        {label}!
      </Text>
    </Text>
    <Text variant="text-body-regular" color="text-secondary" mt="spacer-2">
      Check out your Action Plan to see how you can continue reducing your risk
    </Text>
  </>
);

type ResultFollowUpProps = {
  label: string;
  results: Array<FollowUpType>;
  isMobile: boolean;
};

const ResultFollowUp = ({ label, results, isMobile }: ResultFollowUpProps) => (
  <>
    <IconCatch
      icon={'alert-01'}
      size={isMobile ? 'xl' : 'xxl'}
      mb="spacer-6"
      bgColor={'background-page-02'}
      mx="auto"
    />
    <Text variant="text-header-XS">FOLLOW UP ACTIONS NEEDED</Text>
    <Text variant="text-header-XL">
      Given the results of your{' '}
      <Text as="span" textStyle="text-header-xl-v">
        {label}
      </Text>
      , follow up is required
    </Text>
    <Divider my="spacer-6" />
    <Box
      borderRadius="radii-4"
      border="1px solid"
      borderColor="ui-element-outline-default"
      p="spacer-6"
      textAlign="left"
    >
      <Text variant="text-body-display-XS" mb="spacer-3">
        {results[0].actions}
      </Text>
      <UnorderedList>
        {results[0].descriptions.map((followUpItem) => (
          <Flex
            display="list-item"
            as="li"
            listStyleType="initial"
            listStylePosition="outside"
            key={followUpItem}
            color="text-secondary"
          >
            {followUpItem}
          </Flex>
        ))}
      </UnorderedList>
    </Box>
  </>
);
